import script from "./ExaminationMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ExaminationMenu.vue?vue&type=script&setup=true&lang=js"

export default script